import { getPartnerEmbedConfig } from '@/config/partnerEmbed.js';

const languageRegex = process.env.VUE_APP_LANGUAGE_CODES.split(',').join('|');

export default [
  {
    path: '/embed/c/:sku',
    name: 'product-embed',
    component: () => import(/* webpackChunkName: "product-embed" */ '@/views/embed/ProductEmbedPage.vue'),
    meta: { layout: 'embed', isProductEmbed: true },
  },
  {
    path: '/embed/lightbox/:code',
    name: 'lightbox-embed',
    component: () => import(/* webpackChunkName: "lightbox-embed" */ '@/views/embed/LightboxEmbedPage.vue'),
    meta: { layout: 'embed', isLightboxEmbed: true },
  },
  {
    path: '/embed/:partner',
    name: 'partner-embed',
    component: () => import(/* webpackChunkName: "partner-embed" */ '@/views/embed/PartnerEmbedPage.vue'),
    meta: { layout: 'embed', isPartnerEmbed: true },
    beforeEnter(to, from, next) {
      if (getPartnerEmbedConfig(to.params.partner)) {
        next();
        return;
      }
      next({ name: 'not-found' });
    },
  },
  {
    path: `/:lang(${languageRegex})/embed/c/:sku`,
    component: () => import(/* webpackChunkName: "product-embed" */ '@/views/embed/ProductEmbedPage.vue'),
    meta: { layout: 'embed', isProductEmbed: true },
  },
  {
    path: `/:lang(${languageRegex})/embed/lightbox/:code`,
    component: () => import(/* webpackChunkName: "lightbox-embed" */ '@/views/embed/LightboxEmbedPage.vue'),
    meta: { layout: 'embed', isLightboxEmbed: true },
  },
  {
    path: `/:lang(${languageRegex})/embed/:partner`,
    component: () => import(/* webpackChunkName: "partner-embed" */ '@/views/embed/PartnerEmbedPage.vue'),
    meta: { layout: 'embed', isPartnerEmbed: true },
    beforeEnter(to, from, next) {
      if (getPartnerEmbedConfig(to.params.partner)) {
        next();
        return;
      }
      next({ name: 'not-found' });
    },
  },
];
